/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPencilUp = createReactComponent("outline", "pencil-up", "IconPencilUp", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

export { IconPencilUp as default };
//# sourceMappingURL=IconPencilUp.mjs.map
